// extracted by mini-css-extract-plugin
export default {"daysSelectionContainer":"days-selection_daysSelectionContainer__YRa+I"};